import { AxiosError } from "axios";

export const getAxiosErrorMessage = (error: unknown): string => {
  if (isAxiosError(error)) {
    const data = error.response?.data;
    if (data && typeof data === "object" && "detail" in data) {
      const detail = (data as { detail: unknown }).detail;
      
      if (typeof detail === "string") {
        return detail;
      }
      
      if (typeof detail === "object" && detail !== null) {
        return JSON.stringify(detail);
      }
    }
    
    if (data && typeof data === "object" && "message" in data) {
      const message = (data as { message: unknown }).message;
      if (typeof message === "string") {
        return message;
      }
    }
    
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }

  return "Unknown error occurred";
};

const isAxiosError = (error: unknown): error is AxiosError => {
  return (
    typeof error === "object" &&
    error !== null &&
    "isAxiosError" in error &&
    (error as AxiosError).isAxiosError === true
  );
};

export const toSnakeCase = (str: string) => {
  return str.trim().toLowerCase().replace(/\s+/g, "_");
};
